/* eslint-disable camelcase */
import React from 'react';
import { Card, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    '& p': {
      margin: 3,
    },
  },
  list: {
    backgroundColor: '#dae2e8',
    '& p': {
      '&:first-child': {
        color: 'blue',
      },
    },
  },
}));

const getPredictionText = (label, score, originalLabel) =>
  originalLabel
    ? `${label} (RAW:${originalLabel}): ${score}`
    : `${label}: ${score}`;

const PredictionDetails = ({
  predictionDetails = [],
  predictionsList = [],
}) => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <Grid>
        {predictionDetails.map(({ title, value }) => (
          <Grid container justifyContent="center" key={`${title}_${value}`}>
            <p>{`${title}: ${value}`}</p>
          </Grid>
        ))}
        <Grid container justifyContent="center" className={classes.list}>
          {predictionsList.map(({ label, certainty, original_label }) => (
            <p key={`${label}${certainty}`}>
              {getPredictionText(label, certainty, original_label)}
            </p>
          ))}
        </Grid>
      </Grid>
    </Card>
  );
};

export default React.memo(PredictionDetails);
